import { section } from "@/neon";

import carousel from "@/components/carousel";
import { animateBlogPosts } from "@/lib/animation";

const selectors = {
  carousel: "[data-carousel]",
  slides: ".carousel__slide",
};

section("blog-posts", {
  onLoad() {
    this.slides = this.container.querySelectorAll(selectors.slides);
    this.carouselContainer = this.container.querySelector(
      selectors.carouselContainer
    );

    if (this.slides.length > 1) {
      this.carousel = carousel(this.container);
    }
    this.animateBlogPosts = animateBlogPosts(this.container);
  },

  onUnload() {
    this.animateBlogPosts?.destroy();
    this.carousel && this.carousel.unload();
  },
});
